/**
 * React Query hook for the Exchange Routers screen.
 *
 * Polling cadence: 30s — mirrors the source dashboard's setInterval(30000).
 * The screen is a live operational view for spotting stuck transactions,
 * so a 30s poll is appropriate.
 *
 * A null return value means the endpoint is not yet wired (404).
 * The hook exposes this as data === null; isError stays false.
 */
import { useQuery } from '@tanstack/react-query';
import { fetchExchangeRouters } from '@/api/exchangeRouters';

export function useExchangeRouters() {
  return useQuery({
    queryKey: ['adminExchangeRouters'],
    queryFn: fetchExchangeRouters,
    refetchInterval: 30_000
  });
}
